import DateBox from 'devextreme-react/date-box';
import { LoadPanel } from 'devextreme-react/load-panel';
import { SelectBox } from 'devextreme-react/select-box';
import React from 'react';
import Modal from 'react-modal'; //npm install --save react-modal
import Swal from 'sweetalert2';
import { formatDate, getRequestParams } from '../../helpers/globalfunctions';
import { SendEmailComponent } from '../Shared/SendEmailComponent';
const position = { of: '#historydiv' };

export class InvoiceSummaryGraphComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isOpenModal: false,
            isEmailSubmitted: false,
            isSubmited: false,
            loadPanelVisible: false,
            chkCustomerTypeSelection: "1",
            dropdownCustomerType: [],
            customerTypeId: 0,
            chkPeriodSelection: "1",
            startDate: new Date(new Date().setDate(new Date().getDate() - 1)),
            endDate: new Date(),
            chkReportTypeSelection: "1",
            chkGraphTypeSelection: "1",
            errors: {
                customerTypeId: '',
            }
        }
        this.getCustomerType = this.getCustomerType.bind(this);
        this.handleCustomerTypeChange = this.handleCustomerTypeChange.bind(this);
        this.handleCustomerTypeSelectionChange = this.handleCustomerTypeSelectionChange.bind(this);

        this.handlePeriodSelectionChange = this.handlePeriodSelectionChange.bind(this);
        this.handleFromDateChanged = this.handleFromDateChanged.bind(this);
        this.handleToDateChanged = this.handleToDateChanged.bind(this);

        this.handleReportTypeSelectionChange = this.handleReportTypeSelectionChange.bind(this);
        this.handleGraphTypeSelectionChange = this.handleGraphTypeSelectionChange.bind(this);

        this.downloadAccountPaymentTypeSummaryAsPdf = this.downloadAccountPaymentTypeSummaryAsPdf.bind(this);

        this.handleSearchAccountPaySummaryReportSubmit = this.handleSearchAccountPaySummaryReportSubmit.bind(this);
        this.handleClearSearch = this.handleClearSearch.bind(this);
    }

    showModal = async () => {
        try {
            this.setState({ isOpenModal: true });
        } catch (ex) {
            console.log(ex);
        }
    }
    handleOnAfterOpenModal = async () => {
        try {
            this.setState({ loadPanelVisible: true });
            await this.getCustomerType();
        } catch (ex) {
            console.log(ex);
        }
        this.setState({ loadPanelVisible: false });
    }
    handleOnCloseModal = async () => {

        this.setState({ isOpenModal: false });
        await this.handleClearSearch();
    }

    async getCustomerType() {
        try {
            const requestParams = getRequestParams('GET', '');
            const response = await fetch('customer-type-api/', requestParams);
            const data = await response.json();
            this.setState({
                dropdownCustomerType: data.customerType,
            });

        } catch (e) {
            console.log(e);
        }
    }

    handleCustomerTypeChange(selectedOption) {
        this.setState({ customerTypeId: (selectedOption.selectedItem !== null ? selectedOption.selectedItem.id : 0), })
        this.state.errors["customerTypeId"] = "";
    }

    handleCustomerTypeSelectionChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;

        this.setState({ chkCustomerTypeSelection: value, customerTypeId: 0 });
        this.state.errors["customerTypeId"] = "";
    }

    handlePeriodSelectionChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;

        this.setState({ chkPeriodSelection: value });
    }

    handleReportTypeSelectionChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;

        this.setState({ chkReportTypeSelection: value });
    }

    handleGraphTypeSelectionChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;

        this.setState({ chkGraphTypeSelection: value });
    }

    handleFromDateChanged(event) {
        let fromDateValue = formatDate(event.value, "MM/dd/yyyy");
        this.setState({ startDate: fromDateValue })
    }
    handleToDateChanged(event) {
        let toDateValue = formatDate(event.value, "MM/dd/yyyy");
        this.setState({ endDate: toDateValue })
    }


    handleSearchAccountPaySummaryReportSubmit(e) {
        e.preventDefault();
        if (this.handleValidation()) {
            this.downloadAccountPaymentTypeSummaryAsPdf();
        }
    }
    handleClearSearch() {
        this.setState({
            isSubmited: false,
            isEmailSubmitted: false,
            loadPanelVisible: false,
            chkCustomerTypeSelection: "1",
            dropdownCustomerType: [],
            customerTypeId: 0,

            chkPeriodSelection: "1",
            startDate: new Date(new Date().setDate(new Date().getDate() - 1)),
            endDate: new Date(),

            chkReportTypeSelection: "1",
            chkGraphTypeSelection: "1",

            errors: {
                customerTypeId: '',
            }
        });
    }

    handleValidation() {
        let errors = this.state.errors;
        let formIsValid = true;
        errors.customerTypeId = "";

        if (this.state.chkCustomerTypeSelection === "2" && this.state.customerTypeId === 0) {
            formIsValid = false;
            errors.customerTypeId = "Please select customer type.";
        }

        this.setState({ errors: errors });
        return formIsValid;
    }
    async downloadAccountPaymentTypeSummaryAsPdf() {
        try {
            this.setState({
                isSubmited: true,
            });
            var strRecordSelection = "";
            var fileName = "";
            var strCriteria = "";
            var methodName = "";


            var request = new Object();
            request.LocationId = Number(sessionStorage.getItem("session_locationId"));

            if (this.state.chkReportTypeSelection === "1") {
                methodName = "GetInvoiceSummaryGraphAccount";

                if (this.state.chkGraphTypeSelection === "1") {
                    fileName = "InvoiceSummaryGraphAccount_Pie";
                    if (this.state.chkCustomerTypeSelection === "1") {
                        strRecordSelection = "";
                        strCriteria = " For all Customer Types";
                    } else {
                        let customerType = this.state.dropdownCustomerType.find(opt => opt.id == this.state.customerTypeId);
                        strRecordSelection = " {Proc_Select_Rpt_Invoice_Summary_Pmt;1.Account_Type} = '" + customerType.name + "'";
                      
                        strCriteria = "For Customer Type - " + customerType.name;
                    }
                } else {
                    fileName = "InvoiceSummaryGraphAccount_Bar";
                    if (this.state.chkCustomerTypeSelection === "1") {
                        strRecordSelection = "";
                        strCriteria = " For all Customer Types";
                    } else {
                        let customerType = this.state.dropdownCustomerType.find(opt => opt.id == this.state.customerTypeId);
                        strRecordSelection = " {Proc_Select_Rpt_Invoice_Summary_Customer_Type;1.Account_Type} = '" + customerType.name + "'";
                        strCriteria = "For Customer Type - " + customerType.name;
                    }
                }

            } else  {
                methodName = "GetInvoiceSummaryGraphPayment";

                if (this.state.chkGraphTypeSelection === "1") {
                    fileName = "InvoiceSummaryGraphPayment_Pie";
                    if (this.state.chkCustomerTypeSelection === "1") {
                        strRecordSelection = "";
                        strCriteria = " For all Customer Types";
                    } else {
                        let customerType = this.state.dropdownCustomerType.find(opt => opt.id == this.state.customerTypeId);
                        strRecordSelection = " {Proc_Select_Rpt_Invoice_Summary_Pmt;1.Account_Type} = '" + customerType.name + "'";
                        strCriteria = "For Customer Type - " + customerType.name;
                    }

                } else {
                    fileName = "InvoiceSummaryGraphPayment_Bar";
                    if (this.state.chkCustomerTypeSelection === "1") {
                        strRecordSelection = "";
                        strCriteria = " For all Customer Types";
                    } else {
                        let customerType = this.state.dropdownCustomerType.find(opt => opt.id == this.state.customerTypeId);
                        strRecordSelection = " {Proc_Select_Rpt_Invoice_Summary_Pmt;1.Account_Type} = '" + customerType.name + "'";
                        strCriteria = "For Customer Type - " + customerType.name;
                    }
                }
            } 
            strCriteria = strCriteria + (strCriteria.length > 0 ? ", " : "").toString() + " Date Range: " + formatDate(this.state.startDate, "MM/dd/yyyy") + " - " + formatDate(this.state.endDate, "MM/dd/yyyy");
            request.SelectionCrieteria = strRecordSelection;
            request.Criteria1 = strCriteria;
            request.MethodName = methodName;

            request.ReportType = parseInt(this.state.chkGraphTypeSelection);
            request.StartDate = formatDate(this.state.startDate, "MM/dd/yyyy") + " 00:00:01";
            request.EndDate = formatDate(this.state.endDate, "MM/dd/yyyy") + " 23:59:59";

            request.fileFormat = 'pdf';
            const requestParams = getRequestParams('POST', request);
            const response = await fetch('crystal-report-api', requestParams);
            const dataResponse = await response.json();
            this.setState({
                isSubmited: false,
            });

            let a = document.createElement('a');
            a.href = dataResponse.reportBase64String;
            a.download = fileName + '.pdf';

            a.click();
        } catch (e) {
            this.setState({
                isSubmited: false,
            });
            console.log(e)
        }
    }
    handleOnSendEmail = async (event) => {
        event.preventDefault();
        try {
            if (this.handleValidation()) {
                this.setState({ isEmailSubmitted: true });
                var strRecordSelection = "";
                var fileName = "";
                var strCriteria = "";
                var methodName = "";
                var request = new Object();
                request.LocationId = Number(sessionStorage.getItem("session_locationId"));
                if (this.state.chkReportTypeSelection === "1") {
                    methodName = "GetInvoiceSummaryGraphAccount";

                    if (this.state.chkGraphTypeSelection === "1") {
                        fileName = "InvoiceSummaryGraphAccount_Pie";
                        if (this.state.chkCustomerTypeSelection === "1") {
                            strRecordSelection = "";
                            strCriteria = " For all Customer Types";
                        } else {
                            let customerType = this.state.dropdownCustomerType.find(opt => opt.id == this.state.customerTypeId);
                            strRecordSelection = " {Proc_Select_Rpt_Invoice_Summary_Pmt;1.Account_Type} = '" + customerType.name + "'";

                            strCriteria = "For Customer Type - " + customerType.name;
                        }
                    } else {
                        fileName = "InvoiceSummaryGraphAccount_Bar";
                        if (this.state.chkCustomerTypeSelection === "1") {
                            strRecordSelection = "";
                            strCriteria = " For all Customer Types";
                        } else {
                            let customerType = this.state.dropdownCustomerType.find(opt => opt.id == this.state.customerTypeId);
                            strRecordSelection = " {Proc_Select_Rpt_Invoice_Summary_Customer_Type;1.Account_Type} = '" + customerType.name + "'";
                            strCriteria = "For Customer Type - " + customerType.name;
                        }
                    }

                } else {
                    methodName = "GetInvoiceSummaryGraphPayment";

                    if (this.state.chkGraphTypeSelection === "1") {
                        fileName = "InvoiceSummaryGraphPayment_Pie";
                        if (this.state.chkCustomerTypeSelection === "1") {
                            strRecordSelection = "";
                            strCriteria = " For all Customer Types";
                        } else {
                            let customerType = this.state.dropdownCustomerType.find(opt => opt.id == this.state.customerTypeId);
                            strRecordSelection = " {Proc_Select_Rpt_Invoice_Summary_Pmt;1.Account_Type} = '" + customerType.name + "'";
                            strCriteria = "For Customer Type - " + customerType.name;
                        }

                    } else {
                        fileName = "InvoiceSummaryGraphPayment_Bar";
                        if (this.state.chkCustomerTypeSelection === "1") {
                            strRecordSelection = "";
                            strCriteria = " For all Customer Types";
                        } else {
                            let customerType = this.state.dropdownCustomerType.find(opt => opt.id == this.state.customerTypeId);
                            strRecordSelection = " {Proc_Select_Rpt_Invoice_Summary_Pmt;1.Account_Type} = '" + customerType.name + "'";
                            strCriteria = "For Customer Type - " + customerType.name;
                        }
                    }
                }
                strCriteria = strCriteria + (strCriteria.length > 0 ? ", " : "").toString() + " Date Range: " + formatDate(this.state.startDate, "MM/dd/yyyy") + " - " + formatDate(this.state.endDate, "MM/dd/yyyy");
                request.SelectionCrieteria = strRecordSelection;
                request.Criteria1 = strCriteria;
                request.MethodName = methodName;

                request.ReportType = parseInt(this.state.chkGraphTypeSelection);
                request.StartDate = formatDate(this.state.startDate, "MM/dd/yyyy") + " 00:00:01";
                request.EndDate = formatDate(this.state.endDate, "MM/dd/yyyy") + " 23:59:59";

                request.fileFormat = 'pdf';
                const requestParams = getRequestParams('POST', request);
                const response = await fetch('crystal-report-api', requestParams);
                const dataResponse = await response.json();
                this.setState({ isEmailSubmitted: false });
                let fileData = dataResponse.reportBase64String;
                if (fileData !== null && fileData !== '') {
                    let emailSubject = 'Invoice Summary Graph Report';
                    let attachments = [];
                    let file = new Object();
                    file.fileData = fileData;
                    file.fileName = fileName + '.pdf';
                    file.fileExtension = '.pdf';
                    attachments.push(file);
                    this.refs.sendEmailComponent.showModal('', '', emailSubject, '', attachments);
                }
                else {
                    Swal.fire({
                        allowOutsideClick: false,
                        showCloseButton: true,
                        icon: 'error',
                        title: 'Oops...',
                        text: 'Something went wrong! Unable to process the email request.',
                    })
                }
            }
        } catch (ex) {
            console.log(ex);
        }
        this.setState({ isEmailSubmitted: false });
    }
    render() {
        return (
            <div>
                <Modal ariaHideApp={false}
                    isOpen={this.state.isOpenModal}
                    style={{ content: { width: '45%' } }}
                    className={"react-modal"}
                    onAfterOpen={this.handleOnAfterOpenModal}
                    onRequestClose={this.handleOnCloseModal}
                    shouldCloseOnOverlayClick={false}
                    contentLabel="Example Modal">
                    <form method="post" onSubmit={this.handleSearchAccountPaySummaryReportSubmit}
                        style={(this.state.isSubmited || this.state.isEmailSubmitted) ? { pointerEvents: "none", opacity: "0.4" } : {}}>
                        <div className="modal-header">
                            <h6 className="modal-title">Invoice Summary Graph Report</h6>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={this.handleOnCloseModal}>
                                <span aria-hidden="true">×</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="row">
                                <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                                    <div className="form-group">
                                        <span className="form-check">
                                            <input className="form-check-input" type="radio" name="rdAllCustomerType" value="1" checked={this.state.chkCustomerTypeSelection === "1"} onChange={this.handleCustomerTypeSelectionChange} />
                                            <label className="form-check-label">All Customer</label>
                                        </span>
                                        <span className="form-check">
                                            <input className="form-check-input" type="radio" name="rdSingleCustomerType" value="2" checked={this.state.chkCustomerTypeSelection === "2"} onChange={this.handleCustomerTypeSelectionChange} />
                                            <label className="form-check-label">Single Customer</label>
                                        </span>
                                        <SelectBox
                                            dataSource={this.state.dropdownCustomerType}
                                            className="basic-multi-select"
                                            classNamePrefix="select"
                                            placeholder="Select customer type"
                                            name="ddCustomertype"
                                            defaultValue={0}
                                            value={this.state.customerTypeId}
                                            displayExpr='name'
                                            valueExpr='id'
                                            onSelectionChanged={this.handleCustomerTypeChange}
                                            showClearButton={true}
                                            disabled={this.state.chkCustomerTypeSelection === "1"}
                                            searchEnabled={true}
                                        />
                                        {this.state.errors["customerTypeId"].length > 0 && <span className='error invalid-feedback'>{this.state.errors["customerTypeId"]}</span>}
                                    </div>
                                </div>
                                <div className="col-lg-3 col-md-6 col-sm-6 col-xs-12">
                                    <div className="form-group">
                                        <label htmlFor="">From Date</label>
                                        <DateBox type="date"
                                            className="form-control form-control-sm"
                                            name="fromDate"
                                            placeholder="mm/dd/yyyy"
                                            useMaskBehavior={true}
                                            defaultValue={this.state.startDate}
                                            value={this.state.startDate}
                                            onValueChanged={this.handleFromDateChanged}
                                            width="100%"
                                            disabled={false}
                                            acceptCustomValue={false}
                                        />
                                    </div>
                                </div>
                                <div className="col-lg-3 col-md-6 col-sm-6 col-xs-12">
                                    <div className="form-group">
                                        <label>To Date</label>
                                        <DateBox type="date"
                                            className="form-control form-control-sm"
                                            name="toDate"
                                            placeholder="mm/dd/yyyy"
                                            useMaskBehavior={true}
                                            defaultValue={this.state.endDate}
                                            value={this.state.endDate}
                                            onValueChanged={this.handleToDateChanged}
                                            width="100%"
                                            disabled={false}
                                            acceptCustomValue={false}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                               
                                <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                                    <div className="form-group">
                                        <label htmlFor="">Report Type</label><br />
                                        <span className="form-check">
                                            <input className="form-check-input" type="radio" name="rdByCustomerType" value="1" checked={this.state.chkReportTypeSelection === "1"} onChange={this.handleReportTypeSelectionChange} />
                                            <label className="form-check-label">By CustomerType</label>
                                        </span>
                                        <span className="form-check">
                                            <input className="form-check-input" type="radio" name="rdByPayment" value="2" checked={this.state.chkReportTypeSelection === "2"} onChange={this.handleReportTypeSelectionChange} />
                                            <label className="form-check-label">By Payment</label>
                                        </span>
                                    </div>
                                </div>
                                <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                                    <div className="form-group">
                                        <label htmlFor="">Graph Type</label><br />
                                        <span className="form-check">
                                            <input className="form-check-input" type="radio" name="rdPie" value="1" checked={this.state.chkGraphTypeSelection === "1"} onChange={this.handleGraphTypeSelectionChange} />
                                            <label className="form-check-label">Pie</label>
                                        </span>
                                        <span className="form-check">
                                            <input className="form-check-input" type="radio" name="rdBar" value="2" checked={this.state.chkGraphTypeSelection === "2"} onChange={this.handleGraphTypeSelectionChange} />
                                            <label className="form-check-label">Bar</label>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-success btn-sm" onClick={this.handleOnSendEmail} >
                                {this.state.isEmailSubmitted && <span title="In-process"><i className="fas fa-spinner fa-spin"></i> In-process</span>}
                                {!this.state.isEmailSubmitted && <span title="Send Email"><i className="fas fa-envelope"></i> Send Email</span>}
                            </button>
                            <button type="button" className="btn btn-success btn-sm" title="Download" onClick={this.handleSearchAccountPaySummaryReportSubmit} style={this.state.isSubmited ? { pointerEvents: "none", opacity: "0.4" } : {}}>
                                {this.state.isSubmited && <span title="In-process"><i className="fas fa-spinner fa-spin"></i> In-process</span>}
                                {!this.state.isSubmited && <span title="Search"><i className="fas fa-file-download"></i> Download</span>}
                            </button>
                            <button type="button" className="btn btn-custom-gray btn-sm" title="Clear"
                                onClick={this.handleClearSearch}>
                                <i className="fas fa-eraser"></i> Clear
                                </button>
                            <button type="button" className="btn btn-custom-gray btn-sm" title="Close"
                                onClick={this.handleOnCloseModal}>
                                <i className="fas fa-times"></i> Close
                                </button>
                        </div>
                    </form>
                </Modal>
                <SendEmailComponent ref="sendEmailComponent" />
                <LoadPanel
                    shadingColor="rgba(0,0,0,0.4)"
                    position={position}
                    visible={this.state.loadPanelVisible}
                    showIndicator={true}
                    shading={false}
                    showPane={true}
                    closeOnOutsideClick={false}
                />
            </div >
        )
    }
}